(() => {
  'use strict';

  if (window.__PW_COLLECTION_92__) return;
  window.__PW_COLLECTION_92__ = true;

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function normalizeQuickAdd(root = document) {
    root.querySelectorAll('.collection-grid at-add-to-cart, .pw-product-card at-add-to-cart').forEach((component) => {
      if (component.hasAttribute('data-pw-grid-static')) return;
      const button = component.querySelector(':scope > .js-add-to-cart');
      if (!button || component.dataset.available !== 'true' || component.dataset.variantsSize !== '1') return;

      button.disabled = false;
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', 'Add to cart');

      const label = button.querySelector('.element-button__text, [data-button-text]');
      if (label) label.textContent = 'Add to cart';
      else if (!button.querySelector('svg, .icon')) button.textContent = 'Add to cart';
    });
  }

  function hideInternalFilters(root = document) {
    root.querySelectorAll('.filter__item, .tag, tag, li').forEach((item) => {
      const label = item.querySelector('label, button, a');
      const text = normalize(label?.textContent || item.textContent);

      const isExistingInternalFilter =
        /^(no-discount|cup bundles|cup-bundles)(?:\s*\(\d+\))?$/.test(text);

      const isMetaInternalFilter =
        text.startsWith('pw_meta_');

      const isManuallyHiddenCollection =
        /^(compostable packaging|takeaway packaging|salad bowl lids)(?:\s*\(\d+\))?$/.test(text);

      if (
        isExistingInternalFilter ||
        isMetaInternalFilter ||
        isManuallyHiddenCollection
      ) {
        item.setAttribute('data-pw-hidden-filter', '');
      }
    });
  }

  function init(event) {
    const root =
      event?.target instanceof Element
        ? event.target
        : document;

    hideInternalFilters(root);
    normalizeQuickAdd(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('filter:render', init);
  document.addEventListener('collection:reloaded', init);
  document.addEventListener('ajaxCollection:render', init);
})();

(() => {
  if (window.__PW_COLLECTION_FILTER_TRANSITION_FIX__) return;
  window.__PW_COLLECTION_FILTER_TRANSITION_FIX__ = true;

  const enableCollectionFilterTransitions = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.documentElement.classList.add('pw-collection-filters-ready');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableCollectionFilterTransitions, { once: true });
  } else {
    enableCollectionFilterTransitions();
  }
})();
